import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';

const About = () => (
  <>
    <Header />
    <main style={mainStyle}>
      <h1>About CurrentJobs.co.ke</h1>
      <p><strong>CurrentJobs.co.ke</strong> is a job‑listing aggregator serving job seekers across Kenya. We curate up‑to‑date, verified, and active job opportunities from trusted sources.</p>
      <p>Our platform only displays **current and active job postings**; expired or filled jobs are removed promptly to maintain relevance.</p>
      <h2>Our Mission</h2>
      <ul>
        <li>Provide easy access to live job opportunities from across the internet</li>
        <li>Eliminate scams and outdated listings</li>
        <li>Offer a completely free and registration‑free experience</li>
      </ul>
      <h2>Key Features</h2>
      <ul>
        <li>No user accounts or login required</li>
        <li>No fees to browse or apply to jobs</li>
        <li>Safe, transparent and up‑to‑date listings</li>
      </ul>
      <h2>Copyright & Takedown Requests</h2>
      <p>We respect all intellectual property rights. If you believe a job listing on our site infringes your copyright, please contact us immediately at <a href="mailto:info@currentjobs.co.ke">info@currentjobs.co.ke</a> with:</p>
      <ul>
        <li>Your full name and contact information</li>
        <li>Link or detailed description of the content you believe infringes</li>
        <li>Proof of ownership or authorization</li>
        <li>A signed statement affirming accuracy</li>
      </ul>
      <p>We will respond promptly and remove infringing content as necessary.</p>
    </main>
    <Footer />
  </>
);

const mainStyle = { padding: '2rem', maxWidth: '800px', margin: 'auto', lineHeight: 1.6 };

export default About;
